import { useState, Fragment } from "react";

import { IconButton, CircularProgress } from "@mui/material";

import FleetWebApi from "../Api/FleetWebApi";

import Snackbar from "@mui/material/Snackbar";
import SnackbarContent from "@mui/material/SnackbarContent";
import EditIcon from '@mui/icons-material/Edit';
import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from "@mui/icons-material/Close";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import TextField from "@mui/material/TextField";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { useAuthDataContext, UserRoles } from "../AuthDataProvider";

interface IEditUserFieldProps {
  userId: string,
  fieldKey: string,
  fieldValue: string,
  friendlyField: string,
  details: string,
  fieldType: string,
  updateUser: Function
}


function EditUserField(props: IEditUserFieldProps) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [value, setValue] = useState<string>(props.fieldValue);

  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [error, setError] = useState<null | string>(null);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const handleDialogOpen = () => {
    setIsDialogOpen(true);
  };


  const handleComplete = () => {
    if (isSuccess) {
      setIsDialogOpen(false);
      props.updateUser(props.fieldType === "list" ? value.split(',').map(item => item.trim()) : value);
      setIsLoading(false);
      setIsSuccess(false);
    } else {
      setIsLoading(true);
      FleetWebApi.patchUser(
        props.userId,
        props.fieldKey,
        props.fieldType === "list" ? value.split(",").map(item => item.trim()) : value,
      ).then(
        result => {
          if (result === true) {
            setIsLoading(false);
            setIsSuccess(true);
          } else {
            setSnackbarOpen(true);
            setIsLoading(false);
            setError("An unknown error occured");
          }
        }
      ).catch(error => {
        setSnackbarOpen(true);
        setIsLoading(false);
        setError(error.message);
      })
    }
  };
  const { user } = useAuthDataContext()
  if (user?.roles.includes(UserRoles.admin)) {

    return (
      <Fragment>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
        >
          <SnackbarContent
            className="errorSnackbar"
            message={
              <span id="message-id" className="snackbarMessage">
                <ErrorIcon className="snackbarIcon" />

                {error}
              </span>
            }
            action={[
              <IconButton
                key="close"
                aria-label="close"
                color="inherit"
                onClick={handleSnackbarClose}
              >
                <CloseIcon />
              </IconButton>
            ]}
          />
        </Snackbar>

        {isLoading ? (
          <CircularProgress size={24} />
        ) : (
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            onClick={handleDialogOpen}
          >
            <EditIcon />
          </IconButton>
        )}

        <Dialog
          open={isDialogOpen}
          onClose={handleDialogClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            Edit {props.friendlyField}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>{props.details}</DialogContentText>
            <TextField
              id="noteField"
              label={props.friendlyField}
              value={value}
              onChange={e => setValue(e.target.value)}
              margin="normal"
              fullWidth={true}
            />

          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleDialogClose}
              color="primary"
              variant="contained"
            >
              Cancel
            </Button>
            <div className="buttonWrapper">
              <Button
                onClick={handleComplete}
                color="primary"
                variant="contained"
                disabled={isLoading}
                className={isSuccess ? "buttonSuccess" : ""}
              >
                {isSuccess ? "Close" : "Update"}
              </Button>
              {isLoading && (
                <CircularProgress size={24} className="buttonProgress" />
              )}
            </div>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  } else {
    return (null)
  }

}

export default EditUserField;
